<template>
  <v-card>
    <v-container>
      <v-row no-gutters align="center" class="px-3 mt-4 dialog-menu">
        <v-col
          cols="8"
          class="title text-h5 text-md-h5 font-weight-bold dialog-title"
        >
          <v-icon color="#003088" x-large class="mb-2">
            fa-light fa-circle-info
          </v-icon>
          About CM Web UI
        </v-col>
        <v-col cols="4" class="text-right mb-8">
          <slot name="dialogSize"></slot>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2" md="2" lg="3"></v-col>
        <v-col cols="10" md="10" lg="9">
          <global-logo-display  
            :mdWidth="30"
            :lgWidth="70"
            :showVersion="true"
          >
          </global-logo-display>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-2">
        <v-col cols="4" md="4"></v-col>
        <v-col>
          <b>Version:</b> 
          <span class="px-3">CM WEB UI v{{ uiVersion }}</span>
          <div 
            style="padding-left: 4.5rem;">
            CM REST API v{{ apiVersion }}
          </div>
        </v-col>
      </v-row>
      <v-row class="pt-10">
        <v-col>
          <footer-index bottom></footer-index>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import GlobalLogoDisplay from "@/components/global/global-logo-display.vue";
import FooterIndex from "@/components/footer/footer-index.vue"
import pgwyClient from "@/api/pgwyClient";
import { WEB_UI_VERSION } from "@/config/constants";

export default {
  props: [],
  components: {
    GlobalLogoDisplay,
    FooterIndex
  },
  data() {
    return {
      uiVersion: WEB_UI_VERSION,
      apiVersion: null,
    };
  },
  mounted(){
    this.versionInfo()
  },
  methods: {
    versionInfo(){
      pgwyClient.getStatus().then((res) => {
        this.apiVersion = res.data.version
      }).catch((err) => {
        loggg("err")
        loggg(err)
      })
    }
  },
};
</script>
<style lang="scss">
.dialog-menu {
  border-bottom: 1px solid gainsboro;
}
.dialog-title {
  color: #003088;
}
</style>
